import keyMirror from 'src/utilities/keyMirror';

const PREFIX2 = 'INTERNATIONAL_REMIT';

export const ACTION_TYPES = keyMirror({
  // International Remit Create Types
  [`${PREFIX2}_CREATE_UPDATE_PAGE`]: null,
  [`${PREFIX2}_CREATE_UPDATE_SUB_PAGE`]: null,
  [`${PREFIX2}_CREATE_ADD_DOCUMENT`]: null,
  [`${PREFIX2}_CREATE_EDIT_DOCUMENT`]: null,
  [`${PREFIX2}_CREATE_DELETE_DOCUMENT`]: null,
  [`${PREFIX2}_CREATE_UPDATE_DOCUMENT_STATE`]: null,
  [`${PREFIX2}_CREATE_UPDATE_INVOICE`]: null,
  [`${PREFIX2}_CREATE_UPDATE_SENDER_REF`]: null,
  [`${PREFIX2}_CREATE_UPDATE_RECIPIENT_REF`]: null,
  [`${PREFIX2}_CREATE_UPDATE_SENDER_TYPE`]: null,
  [`${PREFIX2}_CREATE_UPDATE_RECIPIENT_TYPE`]: null,
  [`${PREFIX2}_CREATE_UPDATE_SENDER_DATA`]: null,
  [`${PREFIX2}_CREATE_UPDATE_RECIPIENT_DATA`]: null,
  [`${PREFIX2}_CREATE_UPDATE_RECIPIENT_BANK`]: null,
  [`${PREFIX2}_CREATE_UPDATE_QUOTATION`]: null,
  [`${PREFIX2}_CREATE_UPDATE_TRANSFER_DETAIL`]: null,
  [`${PREFIX2}_CREATE_UPDATE_ATTEMPTS`]: null,
  [`${PREFIX2}_CREATE_UPDATE_SUBMITTED_ID`]: null,
  [`${PREFIX2}_LIST_SHOW_MODAL`]: null,
  [`${PREFIX2}_LIST_COLUMN`]: null,
  [`${PREFIX2}_RESET_CREATE_STATE`]: null,
});
